
import { Vue, Component, Prop } from 'vue-property-decorator';

import { Company, User } from '@/generated/graphql';

import auth from '@/services/auth';

import UPDATE_USER from '@/apollo/user/UpdateUser.gql';
import { parseConfirmationQuery } from '@/utils/parseConfirmationQuery';

import { AmplifyEventBus } from 'aws-amplify-vue';

import UiButton from '@/components/button/ui-button.vue';
import AuthFormLink from '@/components/auth/AuthFormLink.vue';
import AuthCard from '@/components/auth/AuthCard.vue';
import FormGroup from '@/components/form/FormGroup.vue';
import { NOTIFICATION } from '@/entities/Events';
import getAuthData from '@/utils/getAuthData';

import Message, { MessageDuration } from '@/data/notificationsMessages';
import RouteNames from '@/entities/RouteNames';

@Component({
	components: {
		UiButton,
		AuthFormLink,
		AuthCard,
		FormGroup,
	},
})
export default class PaymentV2 extends Vue {
	@Prop({ type: Object, default: () => ({}) }) form!: any;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	loading = false;
	goToPreviousStep() {
		this.$emit('goToPreviousStep');
	}
	formatPhoneNumber(phoneNumber) {
		if (phoneNumber) {
			const phoneStr = phoneNumber.toString();

			return phoneStr.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
		}
		return '';
	}
	async submit() {
		this.loading = true;
		await this.$apollo.mutate({
			mutation: UPDATE_USER,
			variables: {
				set: {
					phone: this.form?.phoneNumber,
					family_name: this.form?.lastName,
					given_name: this.form?.firstName,
					email: this.form?.email,
					emergency_contact: this.form?.emergencyContact,
					profile_completed: true,
				},
				where: { id: { _eq: this.currentUser.id } },
			},
		});
		const uri = `${process.env.VUE_APP_LAMBDA}/send-nextstep-contractor`;
		const { headers } = await getAuthData();
		await this.axios.post(
			uri,
			{
				userId: this.currentUser.id,
			},
			{ headers }
		);
		this.$eventBus.emit(
			NOTIFICATION,
			Message.welcomeOnboard(
				`Feel free to work on some tasks or go to your settings to upload your resume.`
			)
		);
		AmplifyEventBus.$emit('authState', 'projectContrators');
		this.loading = false;
		this.$emit('refetch');
	}
}
